import { createRouter, createWebHashHistory,createWebHistory } from 'vue-router';

import routes from './config';

// console.log(routes)
const router = createRouter({
    history: createWebHashHistory(),
    routes,
    // scrollBehavior() {
    //   return {
    //     el: '#app',
    //     top: 0,
    //     behavior: 'smooth',
    //   };
    // },
});

export default router;